import React from 'react';

import {Icon, WithTooltip} from '@albert-io/atomic';

import type {SortOption} from 'client/Reports/types';

import {HeaderCell} from '../HeaderCell';

export const PROFICIENCY_TOOLTIP_TEXT = 'Only applicable to adaptive subjects';

interface ProficiencyHeaderCellProps {
  onSortClick: (sortKey: string, sortDirection: SortOption) => void;
  sortDirection: SortOption;
  sortBy: string | null;
}

export const PROFICIENCY_SORTS = [
  {
    label: 'Not Started',
    sortKey: 'metrics.count_unpracticed_student_proficiencies_end'
  },
  {
    label: 'Unranked',
    sortKey: 'metrics.count_student_proficiencies_level_0_end'
  },
  {
    label: 'Beginner',
    sortKey: 'metrics.count_student_proficiencies_level_1_end'
  },
  {
    label: 'Intermediate',
    sortKey: 'metrics.count_student_proficiencies_level_2_end'
  },
  {
    label: 'Advanced',
    sortKey: 'metrics.count_student_proficiencies_level_3_end'
  }
] as const;

export const ProficiencyHeaderCell = ({
  onSortClick,
  sortDirection,
  sortBy
}: ProficiencyHeaderCellProps) => {
  const isCurrentSort = !!(
    sortBy &&
    [
      'metrics.count_unpracticed_student_proficiencies_end',
      'metrics.count_student_proficiencies_level_0_end',
      'metrics.count_student_proficiencies_level_1_end',
      'metrics.count_student_proficiencies_level_2_end',
      'metrics.count_student_proficiencies_level_3_end'
    ].includes(sortBy)
  );

  return (
    <HeaderCell
      title={
        <div className='gap-x1 flex'>
          Proficiency
          <WithTooltip content={PROFICIENCY_TOOLTIP_TEXT}>
            <Icon icon={['far', 'info-circle']} />
          </WithTooltip>
        </div>
      }
      showSort
      isCurrentSort={isCurrentSort}
      onSortClick={onSortClick}
      sortDirection={sortDirection}
      sortBy={sortBy}
      sorts={PROFICIENCY_SORTS}
    />
  );
};
